/**
 * Created by razial on 03.04.2025.
 */

Placements.ENTRIES["repairMoveNextRoom"] = {
    type: Placements.FREE_FOCUS_MAIN,
    priority: 200,
    filter: function () {
        const location = cleverapps.meta.getSelectedLocation();
        return location.isRoomCompleted() && !location.isLastRoom();
    },

    action: function () {
        const location = cleverapps.meta.getSelectedLocation();
        location.moveNextRoom();
    }
};

Placements.ENTRIES["repairMoveNextBuilding"] = {
    type: Placements.FREE_FOCUS_MAIN,
    priority: 201,
    filter: function () {
        const location = cleverapps.meta.getSelectedLocation();
        return location.needMoveNextBuilding();
    },

    action: function () {
        const location = cleverapps.meta.getSelectedLocation();
        cleverapps.focusManager.display({
            focus: "moveNextBuilding",
            action: (f) => {
                location.moveNextBuilding(f);
            }
        });
    }
};
